module.exports = __webpack_public_path__ + "static/media/notifications.f4ed7d5d.mp3";